import { TenantKey } from "./types";

/**
 * Custom-domain -> tenant map.
 *
 * Used only on PRE-AUTH pages, when a tenant is served from its own domain
 * (e.g. acme.com) instead of a subdomain (acme.app.com). The hostname alone
 * does not carry the tenant, so we look it up here.
 *
 * Keys must be the lowercased hostname WITHOUT port (window.location.hostname).
 * Resolution order in resolveTenant.ts is: subdomain -> this map -> ?tenant param.
 */
export const customDomains: Record<string, TenantKey> = {
  // "acme.com": "aedc",
  // "portal.lepp.example": "lepp",
};
